<template>
  <v-container v-if="items.length" class="py-10 py-md-13 py-lg-16">
    <div v-for="({ title, subtitle, text }, keyItems) in items" :key="keyItems">
      <TitleWidget
        v-if="title || subtitle"
        :title="title"
        :subtitle="subtitle"
      ></TitleWidget>

      <div
        v-if="text"
        class="
          grey--text
          text--darken-3 text-body-1 text-md-h6 text-center
          font-weight-regular
          mt-5 mt-md-6
          ck-content
          item-text
        "
        v-html="text"
      ></div>
    </div>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";

const _config = {
  mod: "topics",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
  },
};
</script>
